import Storage from 'react-native-storage'

class NamespacedStorage extends Storage {
  constructor(settings) {
    const { namespace = undefined, ...storageSettings } = settings
    super(storageSettings)
    this.namespace = namespace
  }

  loadFromNamespace(params) {
    return this.load({
      ...params,
      id: this.namespace,
    })
  }

  saveInNamespace(params) {
    return this.save({
      ...params,
      id: this.namespace,
    })
  }

  removeFromNamespace(params) {
    return this.remove({
      ...params,
      id: this.namespace,
    })
  }
}

export default NamespacedStorage
